<div class="card" id="banner">
    <img src="../../assets/IMG/other/X2-LN-cover2.jpg" alt="Banner">
    <div class="card-img-overlay text-white d-flex flex-column justify-content-center">
        <h4 class="card-title container">X2 Elite partner</h4>
        <h6 class="card-subtitle mb-2 container">We are part of a global logistics network since 2017</h6>
    </div>
</div>